import * as API from "middleware/api";

const documentType = {
    documentBack: "BackDocument",
    documentFront: "FrontDocument",
    passport: "FrontDocument",
    selfie: "Selfie",
};

export const listStates = () => API.executeAnonymous("/onboarding.states.list");

export const listJobs = () => API.executeAnonymous("/onboarding.jobs.list");

export const listOccupations = () => API.executeAnonymous("/onboarding.occupations.list");

export const listSelectorList = () => API.executeAnonymous("/onboarding.selectors.list");

export const listPersonalInfo = (params) => API.executeAnonymous("/onboarding.personalInfoSelectors.list", params);

export const listLocalities = (params) => API.executeAnonymous("/onboarding.locality.list", params);

export const listRegulatoryInfo = () => API.executeAnonymous("/onboarding.regulatoryInfoSelectors.list");

export const legalRepresentativeSelectors = () =>
    API.executeWithAccessToken("/onboarding.environment.legalRepresentativeSelectors");

export const uploadClientInfo = (
    _documentNumber,
    _email,
    _firstName,
    _lastName,
    _mobile,
    _address,
    _jobInformation,
    _exchangeToken,
    _SSNID,
    _region,
) =>
    API.executeWithExchangeToken(
        "/onboarding.wizard.step5",
        {
            _documentNumber,
            _email,
            _firstName,
            _lastName,
            _mobile,
            _address,
            _jobInformation,
            _SSNID,
            _region,
        },
        _exchangeToken,
    );

export const uploadPicture = (docType, _documentToSave, _exchangeToken, rotatePicture) => {
    const params = {
        _documentToSave,
        isPassport: docType === "passport",
        rotatePicture,
    };
    if (_exchangeToken) {
        switch (documentType[docType]) {
            case documentType.documentFront:
                return API.executeWithExchangeToken("/onboarding.wizard.uploadFrontDocument", params, _exchangeToken);
            case documentType.documentBack:
                return API.executeWithExchangeToken("/onboarding.wizard.uploadBackDocument", params, _exchangeToken);
            case documentType.selfie:
                return API.executeWithExchangeToken("/onboarding.wizard.uploadSelfie", params, _exchangeToken);
            default:
                break;
        }
    }

    switch (documentType[docType]) {
        case documentType.documentFront:
            return API.executeAnonymous("/onboarding.wizard.uploadFrontDocument", params);
        case documentType.documentBack:
            return API.executeAnonymous("/onboarding.wizard.uploadBackDocument", params);
        case documentType.selfie:
            return API.executeAnonymous("/onboarding.wizard.uploadSelfie", params);
        default:
            break;
    }
    return null;
};

export const verifyUsername = (params) => API.executeAnonymous("/onboarding.username.verify", params);
// export const verifyUsername = (params) => ({
//     status: 200,
//     data: {
//         code: "COR000I",
//         data: {
//             isUsernameAvailable: params._userConfirmation !== "Alex4",
//         },
//     },
// });

export const verifyCuitBibank = (params) => API.executeAnonymous("/onboarding.cuit.verify", params);
export const verifyCuitAfip = (params, _exchangeToken) =>
    API.executeWithExchangeToken("/onboarding.afip.verify", params, _exchangeToken);

export const generateNewOperationVU = (idTransaction, exchangeToken) =>
    API.executeWithExchangeToken("/onboarding.new.operation.vu", { idTransaction }, exchangeToken);

export const validateDocument = (
    _documentFrontImage,
    _documentBackImage,
    idTransaction,
    _exchangeToken,
    guestFlow = false,
) =>
    API.executeWithExchangeToken(
        "/onboarding.document.validation.vu",
        {
            _documentFrontImage,
            _documentBackImage,
            idTransaction,
            guestFlow,
        },
        _exchangeToken,
    );

export const validateDocumentMigration = (
    _documentFrontImage,
    _documentBackImage,
    idTransaction,
    _exchangeToken,
    guestFlow = false,
) =>
    API.executeWithExchangeToken(
        "/migration.document.validation.vu",
        {
            _documentFrontImage,
            _documentBackImage,
            idTransaction,
            guestFlow,
        },
        _exchangeToken,
    );

export const validateSelfie = (
    _documentFrontImage = null,
    _documentBackImage = null,
    _selfieList,
    _analysisSelfieList,
    idTransaction,
    document,
    gender,
    _exchangeToken,
    guestFlow = false,
) =>
    API.executeWithExchangeToken(
        "/onboarding.selfie.validation.vu",
        {
            _selfieList,
            _analysisSelfieList,
            idTransaction,
            document,
            gender,
            guestFlow,
            _documentFrontImage,
            _documentBackImage,
        },
        _exchangeToken,
    );

export const validateSelfieMigration = (
    _selfieList,
    _analysisSelfieList,
    idTransaction,
    document,
    gender,
    _exchangeToken,
    guestFlow = false,
) =>
    API.executeWithExchangeToken(
        "/migration.selfie.validation.vu",
        {
            _selfieList,
            _analysisSelfieList,
            idTransaction,
            document,
            gender,
            guestFlow,
        },
        _exchangeToken,
    );

export const verifyCodeSend = (params) => API.executeAnonymous("/onboarding.verificationCode.send", params);

// export const verifyCodeReceive = (params) => API.executeAnonymous("/onboarding.verificationCode.receive", params);
export const verifyCodeReceive = (params, _exchangeToken) =>
    API.executeWithExchangeToken("/onboarding.verificationCode.receive", params, _exchangeToken);
export const verifyCodeReceiveMigration = (params, _exchangeToken) =>
    API.executeWithExchangeToken("/migration.verificationCode.receive", params, _exchangeToken);

export const requestCreateUser = (params, _exchangeToken) =>
    API.executeWithExchangeToken("/onboarding.user.finish", params, _exchangeToken);

export const loginSignatureAccept = (params) =>
    API.executeWithAccessToken("session.login.signature.scheme.accept", params);

export const requestSavePersonalData = (params, _exchangeToken) =>
    API.executeWithExchangeToken("/onboarding.user.personalData", params, _exchangeToken);

export const physicalPersonRead = (params, _exchangeToken) =>
    API.executeWithExchangeToken("/migration.physical.person.save", params, _exchangeToken);

// export const requestSaveRegulatoryData = (params, _exchangeToken) =>
//     API.executeWithExchangeToken("/onboarding.user.regulatoryData", params, _exchangeToken);

export const getUserRole = () => API.executeWithAccessToken("/onboarding.user.getRole");
export const verifyNosisCDA = (params) => API.executeWithAccessToken("/onboarding.nosis.verifyCDA", params);

export const verifyOnbInvitationCode = (params) => API.executeAnonymous("/onboarding.invitationCode.verify", params);

export const processOnboardingEnrolledUser = (params, _exchangeToken) =>
    API.executeWithExchangeToken("/onboarding.process.enrolledUser", params, _exchangeToken);

export const requestTermsAndConditionsAcceptPF = (params) => {
    const { exchangeToken } = params;
    return API.executeWithExchangeToken("/onboarding.terms.and.conditions.pf.accept", params, exchangeToken);
};

export const requestTermsAndConditionsAcceptPJ = (params) =>
    API.executeWithAccessToken("/onboarding.terms.and.conditions.pj.accept", params);
export const processOnboardingEnrolledUserMigration = (params, _exchangeToken) =>
    API.executeWithExchangeToken("/migration.process.enrolledUser", params, _exchangeToken);

export const requestUpdateMigratedUser = (params, _exchangeToken) =>
    API.executeWithExchangeToken("/migration.user.finish", params, _exchangeToken);

export const requestMigrationSavePersonalData = (params, _exchangeToken) =>
    API.executeWithExchangeToken("/migration.user.personalData", params, _exchangeToken);
